import api from "../../service/api";
export default {
  state: () => ({ pairRatePrice: "0" }),
  mutations: {
    SET_PAIR_RATE_PRICE(state, opt) {
      state.pairRatePrice = opt;
    },
  },
  actions: {
    async getQueryPairRateInfo({ commit }, opt) {
      try {
        const queryBalanceData = await api["queryPairRateInfo"](opt);

        queryBalanceData.price = queryBalanceData[0].prices[0].latestPrice;

        commit("SET_PAIR_RATE_PRICE", queryBalanceData.price);
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  getters: {},
};
